import React from 'react';
import moment from "moment";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {fieldStyles, createForm} from 'core/form/createForm';
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {Validate} from 'core/form/validate';
import invoiceService from 'invoice/service/invoiceService';
import mdEntityService from "core/metamodel/mdEntityService";
import commonService from 'core/common/service/commonService';
import securityService from "core/security/securityService";
import {ErrorComp} from 'core/components/errorComp/errorComp';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {lovLabel, FormProps, lovValue} from "core/form/formUtils";
import {optionsSearch} from "core/common/service/commonDataService";
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import {observer} from "mobx-react";
import Grid from "core/grid/domain/grid";
import uiService from "core/common/service/uiService";
import {IssueInvoicesDto, Invoice, Rate} from "invoice/domain/invoiceDomain";
import {observable, action} from "mobx";
import {PARTYROLE} from "party/partyDomain";
import {
  DialogProps, entityStatusCss, validationMessageCss,
  entityStatusText, SteppingDialogAncestor
} from "core/common/page/dialogAncestor";
import MdField, {DATATYPE} from "core/metamodel/mdField";
import {addTenantToQuery} from "core/common/utils/utils";
import {Link} from 'react-router';
import {isFullMonth} from "core/common/utils/dateUtils";
import {PARAMKEY} from "core/security/securityDomain";
import {grey500, orange500, pink500} from "material-ui/styles/colors";

@observer
export default class InvoicesIssueDialog extends SteppingDialogAncestor<DialogProps, undefined, any> {


  @observable private issueInvoicesObject: IssueInvoicesDto;

  @action open(resolve, reject, grid: Grid) {
    uiService.showToolbarActionFlag();

    let gridParams = grid.createFullParams();
    console.log('InvoicesIssueDialog: Opening dialog for ', gridParams);

    this.resolve = resolve;
    this.reject = reject;

    Promise.all([mdEntityService.fetchEntityMetadata(['Invoice'], ["IssueInvoicesDto"]), invoiceService.prepareMultipleIssue(gridParams)])
      .then(action("open-invoiceIssue-actionCb", ([entities, issueInvoicesObject]: [any, IssueInvoicesDto]) => {
        issueInvoicesObject.initAfterRead(true);
        let invoiceDateWrapper = moment(issueInvoicesObject.invoiceDate);
        issueInvoicesObject.startInvoicePeriod = invoiceDateWrapper.startOf('month').format("YYYY-MM-DD");
        issueInvoicesObject.endInvoicePeriod = invoiceDateWrapper.endOf('month').startOf('day').format("YYYY-MM-DD");
        issueInvoicesObject.part = 1;

        this.issueInvoicesObject = issueInvoicesObject;

        this.dialogOpen = true;
        uiService.hideToolbarActionFlag();

      }))
      .catch(error => {
        this.reject(error);
      });

  }


  @action prepare = () => {
    console.log('Preparing issue invoices');

    let form = this.issueInvoicesObject.getForm("InvoicesIssueForm");

    let res = form.validateForm(this.issueInvoicesObject)
      && this.issueInvoicesObject.rates.reduce((acc: boolean, rate: Rate) => {
        return acc && rate.getForm("InvoicesIssueRateForm").validateForm(rate);
      }, true);



    if (!res) {
      return;
    }

    commonService.loading(true);
    invoiceService.doMultipleIssue(this.issueInvoicesObject, 1)
      .then(action("prepare-actionCb", (newIssueInvoicesObject: IssueInvoicesDto) => {
      commonService.loading(false);
      newIssueInvoicesObject.part = 2;
      newIssueInvoicesObject.showErrors = true;
      this.issueInvoicesObject = newIssueInvoicesObject;
      //this.resolve(count);
    }), error => {
      this.$errors = error.getMessages();
    });

  };

  @action ok = () => {
    console.log('Issuing invoices');

    commonService.loading(true);
    invoiceService.doMultipleIssue(this.issueInvoicesObject, 2)
      .then(action("ok-actionCb", (newIssueInvoicesObject: IssueInvoicesDto) => {
      commonService.loading(false);
      newIssueInvoicesObject.part = 3;
      newIssueInvoicesObject.showErrors = false;
      this.issueInvoicesObject = newIssueInvoicesObject;
    }), error => {
      this.$errors = error.getMessages();
    });
  };

  @action close = () => {
    this.issueInvoicesObject = null;
    this.resolve(null);
  };

  @action cancel = (evt) => {
    console.log('InvoiceIssueDialog#cancel evt = %O', evt);
    this.issueInvoicesObject = null;
    this.reject(null);
  };

  @action onShowErrors = (evt) => {
    this.issueInvoicesObject.showErrors = evt.target.checked;
  };


  render() {

    let {entities} = this.props;

    if (!(this.issueInvoicesObject && this.dialogOpen)) return null;

    let issuableCount = this.issueInvoicesObject.customerNoErrorCount();

    let cancelButton = <FlatButton label="Cancel" tabIndex={0} primary onClick={this.cancel} />;

    let showErrorCheckbox = <MdCheckbox label="Show Errors" checked={this.issueInvoicesObject.showErrors} labelStyle={{whiteSpace: 'nowrap'}} style={{display: 'inline-block', width: 140, verticalAlign: 'middle'}} onCheck={this.onShowErrors} />;

    let actions;

    if (this.issueInvoicesObject.part === 1) {
      actions = [cancelButton, <FlatButton label="Prepare Issue" secondary onClick={this.prepare} disabled={!this.issueInvoicesObject.tupleMap.hasTenantAnyEntityNumberGen}/>];
    } else if (this.issueInvoicesObject.part === 2) {
      actions = [showErrorCheckbox, cancelButton,
        <FlatButton label="Recheck" secondary onClick={this.prepare}/>, <FlatButton label="Issue !" secondary onClick={this.ok} disabled={issuableCount === 0}/>];
    } else if (this.issueInvoicesObject.part === 3) {
      actions = [showErrorCheckbox, <FlatButton label="Close" primary onClick={this.close} />];
    }


    console.debug("rendering InvoicesIssueDialog ", this.issueInvoicesObject);


    return (
      <Dialog
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={{width: '80%', maxWidth: 800}}
        bodyStyle={{overflow: 'visible'}}
      >


        <Stepper activeStep={this.issueInvoicesObject.part - 1}>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> {`Prepare issue (${this.issueInvoicesObject.customerIds.length})`} </StepLabel>
          </Step>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> { `Do Issue (${issuableCount})` } </StepLabel>
          </Step>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> { `Done (${ (this.issueInvoicesObject.part === 3) ? issuableCount : 0})` }  </StepLabel>
          </Step>
        </Stepper>


        {(!this.issueInvoicesObject.tupleMap.hasTenantAnyEntityNumberGen) ?
          (
            <div style={{display: 'flex'}}>
              <h5 style={{marginRight: 2, color: pink500, marginTop: 12}}>There is no number generation configuration, please create one.</h5>
            </div>
          ) : null}


        <ErrorComp messages={this.$errors}/>

        {
          (this.issueInvoicesObject.part === 1) ? <InvoicesIssueForm entities={entities}  entity={entities.get('IssueInvoicesDto')} dataObject={this.issueInvoicesObject} rootObject={this.issueInvoicesObject} />
            : (
            <div style={{overflowY: 'auto', maxHeight:500}}>
              <table className="table table-condensed fullwrap">
                <tbody>
                {this.issueInvoicesObject.customerStatuses.filter( cs => this.issueInvoicesObject.showErrors || cs.status !== 'ERROR' ).map( (cs, index) => {
                  let _className = entityStatusCss(cs);
                  return (
                  <tr key={index}>
                    <td className={_className}>
                      <Link to="partyDetail" params={{id: lovValue(cs.entityObject)}}  query={addTenantToQuery()}><span className={_className}>{lovLabel(cs.entityObject)}</span></Link>
                      { (cs.messages && cs.messages.length) ? (
                        <table style={{marginLeft: 20}}>
                          <tbody>
                          {cs.messages.map( (messageObj, index) => (
                            <tr key={index}><td className={validationMessageCss(messageObj)}>{messageObj.message}</td></tr>
                          ))}
                          </tbody>
                        </table>
                      ) : null}
                    </td>
                    <td className={_className}>
                      {entityStatusText(cs)}
                    </td>
                  </tr>
                )})}
                </tbody>
              </table>
            </div>
          )
        }



      </Dialog>
    );
  }


}


interface InvoicesIssueFormState {
  servicePeriod: string;
}

@createForm({
  formName: 'InvoicesIssueForm',
  fields: [{
    name: 'invoiceDate',
    validators: ['IsRequired']
  }, {
    name: 'taxDate',
    validators: ['IsRequired']
  }, {
    name: 'startInvoicePeriod',
    validators: ['IsRequired']
  }, {
    name: 'invoiceAdjustmentKoef',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'paymentType',
    validators: ['IsRequired']
  }, {
    name: 'endInvoicePeriod',
    validators: ['IsRequired']
  }, {
    name: 'issuedBy'
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'internalComment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'profitCenter'
  }]
}, () => <noscript/>)
@observer
class InvoicesIssueForm extends React.Component<FormProps<IssueInvoicesDto, IssueInvoicesDto>, InvoicesIssueFormState> {

  state = {servicePeriod: 'thisMonth'};


  @action onChangeServicePeriod = (evt, servicePeriod: string) => {
    console.log('onChangeServicePeriod ', servicePeriod);

    let {dataObject, rootObject} = this.props;

    if (servicePeriod === 'thisMonth') {
      dataObject.startInvoicePeriod = moment(dataObject.invoiceDate).startOf('month').format("YYYY-MM-DD");
      dataObject.endInvoicePeriod = moment(dataObject.invoiceDate).endOf('month').startOf('day').format("YYYY-MM-DD");
    } else if (servicePeriod === 'previousMonth') {
      dataObject.startInvoicePeriod = moment(dataObject.invoiceDate).subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
      dataObject.endInvoicePeriod = moment(dataObject.invoiceDate).subtract(1, 'months').endOf('month').startOf('day').format("YYYY-MM-DD");
    }

    this.setState({servicePeriod});
  };

  @action onChangeInvoiceDate = () => {
    let {dataObject, rootObject} = this.props;
    console.log('onChangeInvoiceDate ', dataObject.invoiceDate);
    if (dataObject.invoiceDate) {
      dataObject.taxDate = dataObject.invoiceDate;
    }

    rootObject.$dirty = true;
  };


  @action onChangeRate = (rateObject, value) => {
    let {rootObject} = this.props;
    console.log('onChangeRate: ', value);
    rateObject.rate = (value == null) ? '' : value;
    rootObject.$dirty = true;
  };

  issuedByFO = (option, filter) => {
    return option;
  };


  render() {
    let {dataObject, rootObject, entities, entity, index, formName} = this.props;
    let {invoiceDate, taxDate, startInvoicePeriod, endInvoicePeriod, paymentType, profitCenter, issuedBy, internalComment, comment, invoiceAdjustmentKoef}
      = dataObject.getFormFields(formName);

    let months;
    if (dataObject.startInvoicePeriod && dataObject.endInvoicePeriod) {
      let duration = moment.duration( moment(dataObject.startInvoicePeriod).diff(moment(dataObject.endInvoicePeriod), 'month',true));
      months = duration.asMonths();
      console.log(months);
    }


    return (
      <form>

        <h5 className="color-amber-600">{(dataObject.startInvoicePeriod && dataObject.endInvoicePeriod && !isFullMonth(dataObject.startInvoicePeriod, dataObject.endInvoicePeriod))
            ? "Invoice Period is not one full month, Invoices with prepaid (longer than one month) periods will not be generated" : null}</h5>

        <div className="row">
          <div className="col-xs-12 col-sm-6">

            {(securityService.getTenantParam(PARAMKEY.BATCH_INVOICE_SPLIT_PROFIT_CENTER)) ?
            <div className="row">
              <div className="fx col-xs-10">
                <StyledSelect {...profitCenter.props}  />
                <Validate field={profitCenter} value={profitCenter.props.value}/>
              </div>
            </div>
            : null}

            <div className="row">
              <div className="fx col-xs-10">
                <StyledSelect {...paymentType.props}  />
                <Validate field={paymentType} value={paymentType.props.value}/>
              </div>
            </div>
            <div className="row">
              <div className="fx col-xs-10">
                <StyledDatePicker {...invoiceDate.props}   />
                <Validate field={invoiceDate} value={invoiceDate.props.value} onSuccess={this.onChangeInvoiceDate}/>
              </div>
            </div>
            <div className="row">
              <div className="fx col-xs-10">
                <StyledDatePicker {...taxDate.props}  />
                <Validate field={taxDate} value={taxDate.props.value}/>
              </div>
            </div>
            <div className="row">
              <div className="fx col-xs-10">
                <StyledSelect  {...issuedBy.props} async loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.USER_ROLE]})}
                                                    clearable asterixForAll />
              </div>
            </div>




            <div className="row">
              <div className="col-xs-10">
                <StyledDateInterval {...startInvoicePeriod.props} valueFrom={startInvoicePeriod.props.value} valueTo={endInvoicePeriod.props.value}
                                    onChangeFrom={startInvoicePeriod.props.onChange} onChangeTo={endInvoicePeriod.props.onChange} />
                <Validate field={startInvoicePeriod} value={startInvoicePeriod.props.value}/>
                <Validate field={endInvoicePeriod} value={endInvoicePeriod.props.value}/>
              </div>
            </div>

            <div className="row">
              <div className="fx col-xs-10">
                <NumberField {...invoiceAdjustmentKoef.props}  />
                <Validate field={invoiceAdjustmentKoef} value={invoiceAdjustmentKoef.props.value}/>
              </div>
            </div>


          </div>

          <div className="col-xs-12 col-sm-6">

            <h6>Rates for Invoice currency / Local curency:</h6>
            <table className="table table-condensed fullwrap">
              <tbody>
              {
                (dataObject.rates) ?
                  dataObject.rates.map((rateObject, index) => (
                    <InvoicesIssueRateForm entities={entities} dataObject={rateObject} rootObject={dataObject} />
                  ))
                  : null
              }
              </tbody>
            </table>

            <div className="row">
              <div className="fx col-xs-12">
                <MdTextField {...comment.props} multiLine={true} rows={2}  />
              </div>
            </div>
            <div className="row">
              <div className="fx col-xs-12">
                <MdTextField {...internalComment.props} multiLine={true} rows={2}  />
              </div>
            </div>

          </div>

        </div>


      </form>


    );
  }
}




@createForm({
  formName: 'InvoicesIssueRateForm',
  fields: [{
    name: 'rate',
    mdField: new MdField({label: 'Size', dataType: DATATYPE.NUMBER }),
    validators: ['IsRequired', 'IsNumber']
  }]
}, () => <noscript/>)
@observer
class InvoicesIssueRateForm extends React.Component<FormProps<Rate, IssueInvoicesDto>, undefined> {

  render() {
    const {dataObject, rootObject, entity, index, entities, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {rate} = fields;

    return (
      <tr key={index}>
        <td style={{verticalAlign: 'bottom', lineHeight: 2.9}}>{dataObject.ccy1 + '/' + dataObject.ccy2}</td>
        <td>
          <NumberField {...rate.props} {...fieldStyles.small.styledSelect} />
          <Validate field={rate} value={rate.props.value}/>
        </td>
        <td style={{color: grey500, fontSize: 12, verticalAlign: 'bottom'}}>{dataObject.label}</td>
      </tr>
    );
  }
}





// WEBPACK FOOTER //
// ./src/invoice/component/invoicesIssueDialog.tsx